import { Directive, Input, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTextLength]',
})
export class TextLengthDirective {
  @Input() appTextLength: number;

  constructor(private ngControl: NgControl) {}

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const maxLength = this.appTextLength || 100;
    const pastedText = event.clipboardData.getData('text');
    const trimmedText = pastedText.substring(0, maxLength);
    event.preventDefault();
    document.execCommand('insertText', false, trimmedText);
  }

  @HostListener('input', ['$event']) onInput(event: Event) {
    const maxLength = this.appTextLength || 100;
    const currentValue = this.ngControl.value || '';
    if (currentValue.length > maxLength) {
      this.ngControl.control.setValue(currentValue.substring(0, maxLength), { emitEvent: false });
    }
  }
}
